export interface GradedResponse {
  id: string
  complexity: string
  correctness: number
  comments: string
}
